export default __webpack_public_path__ + "static/media/vietgot-screenshot-02.bb3985ed.png";